import angelaPic from "@/public/images/artists/angela.png";
import { Artist } from "@/types/types";

export const angela = {
  id: "36",
  name: "Angela",
  image: angelaPic,
  description: `Meet "Angela" the voice model tailored for pop and electronic music. Her vocals fuse melodic warmth with electronic flair, adding a fresh dimension to tracks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fangela-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Ballads"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
